import { styled } from '@vebox/etui-system';
import { PureComponent, createElement, cloneElement } from 'react';
import { c as _defineProperty } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import { defaultProps } from './defaultSettings.js';

const ArrowWrapperDiv = styled(Div)`
  cursor: pointer;
  position: fixed;
`;

const ArrowDefaultProps = {
  disabledClass: defaultProps.arrowDisabledClass
};

/** Wrapper component for arrows */
class ArrowWrapper extends PureComponent {
  render() {
    const {
      isDisabled,
      className: clsName,
      disabledClass,
      onClick,
      children
    } = this.props;
    const className = `${clsName} ${isDisabled ? disabledClass : ''}`;
    const clickHandler = () => {
      return onClick();
    };
    return /*#__PURE__*/createElement(ArrowWrapperDiv, {
      className: className,
      onClick: clickHandler
    }, /*#__PURE__*/cloneElement(children, children.props));
  }
}
_defineProperty(ArrowWrapper, "defaultProps", ArrowDefaultProps);

export default ArrowWrapper;
